const CURRENCY_SYMBOLS = {
  USD: "$",
  INR: "₹",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  CAD: "CA$",
  AUD: "A$",
  CNY: "¥",
};

/**
 * Gets the symbol for a given currency code.
 * Falls back to the code itself if no symbol is found.
 */
export const getCurrencySymbol = (code) => {
  if (!code) return "";
  return CURRENCY_SYMBOLS[code.toUpperCase()] || code;
};

/**
 * Formats a number as a currency string with dynamic symbol.
 */
export const formatCurrency = (amount, code, decimals = 2) => {
  const symbol = getCurrencySymbol(code);
  const numericAmount = parseFloat(amount) || 0;
  
  const formattedAmount = numericAmount.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  
  if (!symbol) return formattedAmount;
  
  // Standard prefix for most currencies with a space for readability
  return `${symbol} ${formattedAmount}`;
};
